'use client';
import { memo, useState } from 'react';
import { HStack, Stack } from '@chakra-ui/react';

import { breakpoints } from 'app/themeConfig';
import SliderControls from 'features/SliderControls';
import { useSwiperControls } from 'shared/hooks';
import BlockHeader from 'shared/BlockHeader';
import StepsCard from './StepsCard';
import Slider from 'shared/Slider';

import { stepsCardsSliderPropsSelector } from 'constants/StepsCardsSlider';

const StepsCardsSlider = ({ type }) => {
  const { title = 'Как мы работаем', cardsData } = stepsCardsSliderPropsSelector[type];
  const [swiper, setSwiper] = useState(null);
  const controls = useSwiperControls(swiper);

  return (
    <Stack w="full" align="start" gap={{ laptop: '48px', tablet: '32px', mobile: '24px' }}>
      <HStack w="full" justify="space-between" align="end">
        <BlockHeader>{title}</BlockHeader>

        <SliderControls {...controls} />
      </HStack>

      <Slider
        controller={swiper}
        setController={setSwiper}
        slidesData={cardsData}
        SlideComponent={StepsCard}
        mousewheel={false}
        spaceBetween="0"
        breakpoints={{ [parseInt(breakpoints.xm)]: { slidesPerView: 'auto' } }}
      />
    </Stack>
  );
};

export default memo(StepsCardsSlider);
